/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init'; // Necessário apenas se usar i18n

/***************************************************************************************************
 * Zone Flags Configuration (Desabilite patches desnecessários)
 */
import './zone-flags';

/***************************************************************************************************
 * Zone JS é necessário para o Angular
 */
import 'zone.js';

/***************************************************************************************************
 * Outros polyfills sob demanda podem ser importados diretamente aqui, se necessário
 */
